import React, { useEffect } from "react";

const disableCountryDropdown = () => {
    const countryDropdown = document.querySelector('.wu-footer--landing-page__top__col__input-field');
    const titleBelowDropdown = countryDropdown.parentElement.querySelector('.wu-footer--landing-page__top__col--lg__title');
    titleBelowDropdown.classList.remove('mar-xxl-tp');
    countryDropdown.remove();
}

export default function FooterComponent({
    content,
    countryDropdownDisable
}) {
    useEffect(() => {
        countryDropdownDisable === 'Yes' && disableCountryDropdown();
    },[]);
    return (
        <div className="entry-content" dangerouslySetInnerHTML={{ __html: content }} ></div>
    )
}
